<template>
	<div class="dataFieldBox">
		<div class="queryBtn">
			<div class="sourceField">
				<span class="sourceFieldTitle">源字段：</span>
				<el-select size="medium" v-model="sourceFielaNameValue" placeholder="请选择" style="min-width: 98px;">
					<el-option v-for="item in sourceFielaNameList" :key="item" :label="item" :value="item"></el-option>
				</el-select>
			</div>
			<div class="targetField">
				<span class="targetFieldTile">目标字段：</span>
				<el-select size="medium" v-model="targetFielaNameValue" placeholder="请选择" style="min-width: 98px;">
					<el-option v-for="item in targetFielaNameList" :key="item.value" :label="item.chfieldName"
						:value="item.chfieldName"></el-option>
				</el-select>
			</div>
			<el-button type="primary" size="medium" style="width: 98px;" @click="addMap">添加映射</el-button>
		</div>
		<div class="expository">
			<span v-if="source=='df'">
				必须映射目标字段中的电话号码，
			</span>
			没有对应字段可以直接添加映射，系统将自动创建目标字段
		</div>
		<div class="topTable">
			<el-table border :data="tableData" style="width: 100%" max-height="500">
				<el-table-column class="topTableTh" align="center" prop="chfieldName" label="源字段">
				</el-table-column>
				<el-table-column align="center" prop="targetfield" label="目标字段">
					<template slot-scope="scope">
						<span v-if="scope.row.targetfield == ''" style="color:#47C72D">创建字段</span>
						<span v-else>{{ scope.row.targetfield }}</span>
					</template>
				</el-table-column>
				<el-table-column align="center" label="操作" width="150">
					<template slot-scope="scope">
						<el-link type="primary" :underline="false" @click="deleteRow(scope.$index, scope)">删除</el-link>
					</template>
				</el-table-column>
			</el-table>
			<div class="block">
				<el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
					:current-page="pagination.currentPage" :page-sizes="[10, 20, 30, 50]"
					:page-size="pagination.pageSize" layout="total, sizes, prev, pager, next, jumper"
					:total="pagination.total"></el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		data
	} from 'jquery';
	export default {
		props: {
			filePath: {
				type: String
			},
			keyType: {
				type: String
			},
			fileData: {
				type: String
			}
		},
		data() {
			return {
				source: '',
				id: '',
				sourceFielaNameList: [], //源字段
				targetFielaNameList: [], //目标字段
				sourceFielaNameValue: '',
				targetFielaNameValue: '',
				currentPage4: 1,
				tableData: [],
				pagination: {
					currentPage: 1,
					total: 0,
					pageSize: 10
				}
			};
		},
		created() {
			console.log(this.filePath);
			this.id = this.$route.query.id;
			this.source = this.$route.query.source;
			this.getFieldName();
		},
		methods: {
			deleteRow(index, rows) {
				console.log(rows);
				let newsourcefie = JSON.parse(JSON.stringify(rows.row));
				let type = false;
				this.sourceFielaNameList.forEach(item => {
					if (item == newsourcefie.chfieldName) {
						type = true;
					}
				});
				if (!type) {
					this.sourceFielaNameList.push(newsourcefie.chfieldName);
				}
				this.tableData.splice(index, 1);
			},
			addMap() {
				if (this.sourceFielaNameValue == '') {
					this.$message('请选择源字段');
					return false;
				}
				let newfield = {
					chfieldName: this.sourceFielaNameValue,
					targetfield: this.targetFielaNameValue,
					id: Math.random()
				};
				this.sourceFielaNameList.forEach((item, index) => {
					if (item == this.sourceFielaNameValue) {
						this.sourceFielaNameList.splice(index, 1);
					}
				});
				this.targetFielaNameValue = '';
				this.sourceFielaNameValue = '';
				this.tableData.push(newfield);
				this.pagination.total = this.tableData.length;

				console.log(this.tableData);
				// 调整结构
				let newTableData = [];
				this.tableData.forEach((item, index) => {
					console.log(item, index);
					let newObj = {};
					newObj[item.chfieldName] = item.targetfield;
					// newObj['"'+item.chfieldName+'"'] = item.targetfield
					newTableData.push(newObj);
				});
				this.$emit('fileDataList', JSON.stringify(newTableData),1);
			},
			// 点击下一步时获取创建好的数据结构
			queryNewtableData() {
				// let newfield = {
				// 	chfieldName: this.sourceFielaNameValue,
				// 	targetfield: this.targetFielaNameValue,
				// 	id: Math.random()
				// };
				this.sourceFielaNameList.forEach((item, index) => {
					if (item == this.sourceFielaNameValue) {
						this.sourceFielaNameList.splice(index, 1);
					}
				});
				this.targetFielaNameValue = '';
				this.sourceFielaNameValue = '';
				// this.tableData.push(newfield);
				this.pagination.total = this.tableData.length;

				console.log(this.tableData);
				
				// 调整结构
				let newTableData = [];
				this.tableData.forEach((item, index) => {
					console.log(item, index);
					let newObj = {};
					newObj[item.chfieldName] = item.targetfield;
					// newObj['"'+item.chfieldName+'"'] = item.targetfield
					newTableData.push(newObj);
				});
				this.$emit('fileDataList', JSON.stringify(newTableData),2);
			},
			queryAllFieldName() {
				//无用接口
				let that = this;
				let params = {
					that: this,
					url: `${this.$config.service.queryAllFieldName}`,
					method: 'POST',
					data: {
						qid: that.id
					},
					cb(res) {
						if (res.code == 0) {
							that.tableData = res.resultBody;
						} else {
							that.tableData = [];
						}
					}
				};
				this.$util.request(params);
			},
			getFieldName() {
				let that = this;
				let params = {
					that: this,
					url: `${this.$config.service.getFieldName}`,
					method: 'POST',
					data: {
						qid: that.id,
						uplodFieldUrl: that.filePath,
						separatorText: that.keyType
					},
					cb(res) {
						if (res.code == 0) {
							that.tableData = []
							console.log(res);
							that.sourceFielaNameList = res.resultBody.sourceFielaNameList;
							let targetFielaNameList = res.resultBody.targetFielaNameList;
							let newTargetFielaNameList = [];
							targetFielaNameList.forEach((item, index) => {
								if (item.isSysField == 1) {
									if (item.enfieldName == 'phone' || item.enfieldName == 'piAreaCode' || item
										.enfieldName == 'piExt') {
										newTargetFielaNameList.push(item);
									}
								} else {
									newTargetFielaNameList.push(item);
								}
							});
							newTargetFielaNameList.forEach(item => {
								that.sourceFielaNameList.forEach((item2, index2) => {
									if (item.chfieldName == item2) {
										let newfield = {
											chfieldName: item2,
											targetfield: item.chfieldName,
											id: Math.random()
										};
										that.tableData.push(newfield);
										that.pagination.total = that.tableData.length;
										that.sourceFielaNameList.splice(index2, 1);
									}
								});
							});
							that.targetFielaNameList = newTargetFielaNameList;
							console.log(that.fileData);
							if (that.fileData != '') {
								console.log(that.sourceFielaNameList);
								console.log(that.targetFielaNameList);
								let tempData = [];
								let fileData = JSON.parse(that.fileData);
								fileData.forEach(item => {
									for (let key in item) {
										let newfield = {
											chfieldName: key,
											targetfield: item[key],
											id: Math.random()
										};
										that.tableData.push(newfield);
										that.pagination.total = that.tableData.length;
										that.sourceFielaNameList.forEach((item2, index2) => {
											if (key == item2) {
												that.sourceFielaNameList.splice(index2, 1);
											}
										});
									}
								});
							}
							that.tableData  = that.unique(that.tableData)
							console.log('表格数据',that.tableData)

						}
					}
				};
				this.$util.request(params);
			},
			 unique(arr) {
			    const res = new Map();
			    return arr.filter((arr) => !res.has(arr.chfieldName) && res.set(arr.chfieldName, 1));
			   },

			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
			},
			handleCurrentChange(val) {
				console.log(`当前页: ${val}`);
			}
		}
	};
</script>

<style lang="scss" scoped>
	.dataFieldBox {
		width: 72%;
		margin: 20px auto;

		.queryBtn {
			display: flex;
			margin-bottom: 10px;
			margin-top: 40px;

			.sourceField {
				position: relative;

				.sourceFieldTitle {
					position: absolute;
					top: -25px;
					left: 0px;
				}
			}

			.targetField {
				position: relative;
				margin: 0px 20px;

				.targetFieldTile {
					position: absolute;
					top: -25px;
					left: 0px;
				}
			}
		}

		.expository {
			margin-bottom: 10px;
			color: #909090;
		}

		.topTable {
			margin-bottom: 20px;

			.radioBtn {
				text-align: right;
				margin-top: 20px;
			}

			.block {
				text-align: right;
				margin-top: 20px;
			}
		}
	}
</style>
